/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SettlementCosts from "./SettlementCosts";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type CostBoxProps = {
  settlement: AbstractCase;
};

const CostBox = ({ settlement }: CostBoxProps) => {
  if (settlement.isInitialProxy || (settlement.noWinNoFee && !settlement.nWnFAmount)) {
    return null;
  }

  return (
    <ContentBox headline={"Abfindung & Kosten"}>
      {settlement && <SettlementCosts settlement={settlement} />}
    </ContentBox>
  );
};

export default CostBox;
